import { Suspense, useEffect } from 'react'
import { Outlet } from 'react-router'
import { Loading } from 'shared-ui/components'

import NavBar, { NAV_BAR_BORDER_TOP_WIDTH_PX, NAV_BAR_HEIGHT_PX } from './NavBar'

const AppShell: React.FC = () => (
  <div className="flex min-h-dvh flex-col leading-tight">
    <NavBar />
    <Outlet />
  </div>
)

export const ScrollContent: React.FC = () => {
  useEffect(() => {
    const initial = document.body.style.overflowY
    document.body.style.overflowY = 'scroll'
    return () => {
      document.body.style.overflowY = initial
    }
  }, [])

  return (
    <Suspense fallback={<Loading />}>
      <div className="relative grow">
        <Outlet />
      </div>
    </Suspense>
  )
}

export const FixedContent: React.FC = () => (
  <Suspense fallback={<Loading />}>
    <div
      className="lg:h-[calc(100dvh-var(--nav-height))] lg:overflow-hidden"
      style={{
        '--nav-height': `${NAV_BAR_HEIGHT_PX + NAV_BAR_BORDER_TOP_WIDTH_PX}px`
      }}
    >
      <Outlet />
    </div>
  </Suspense>
)

export default AppShell
